var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67143e-05 10.7658V15.0058C1.67143e-05 15.271 0.105374 15.5254 0.29291 15.7129C0.480447 15.9004 0.7348 16.0058 1.00002 16.0058H5.24002C5.37162 16.0066 5.50209 15.9813 5.62392 15.9316C5.74576 15.8818 5.85658 15.8085 5.95002 15.7158L12.87 8.7858L15.71 6.0058C15.8037 5.91284 15.8781 5.80223 15.9289 5.68038C15.9797 5.55852 16.0058 5.42781 16.0058 5.2958C16.0058 5.16379 15.9797 5.03308 15.9289 4.91122C15.8781 4.78936 15.8037 4.67876 15.71 4.5858L11.47 0.295798C11.3771 0.20207 11.2665 0.127676 11.1446 0.0769069C11.0227 0.0261382 10.892 0 10.76 0C10.628 0 10.4973 0.0261382 10.3754 0.0769069C10.2536 0.127676 10.143 0.20207 10.05 0.295798L7.23002 3.1258L0.290017 10.0558C0.197335 10.1492 0.12401 10.2601 0.0742455 10.3819C0.0244809 10.5037 -0.000744179 10.6342 1.67143e-05 10.7658ZM10.76 2.4158L13.59 5.2458L12.17 6.6658L9.34002 3.8358L10.76 2.4158ZM2.00002 11.1758L7.93002 5.2458L10.76 8.0758L4.83002 14.0058H2.00002V11.1758Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_paint",
    x1: 16.0058,
    y1: 0,
    x2: -0.407598,
    y2: 0.429503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB79F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#5F49B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.7f6bdca7efc191763e2392c3f4b7e885.svg";
export { ForwardRef as ReactComponent };